import { createReducer } from '@reduxjs/toolkit';
import { profilePreferenceActions } from './actions';

export interface ProfilePreferencesState {
  theme: string;
  isMetric: boolean;
}

const profilePreferencesInitialState: ProfilePreferencesState = {
  theme: (window.localStorage.getItem('dq.theme') as any) ?? 'system',
  isMetric: false,
};

export const preferencesReducer = createReducer(profilePreferencesInitialState, builder =>
  builder
    .addCase(profilePreferenceActions.setTheme, (state, action) => {
      state.theme = action.payload;
    })
    .addCase(profilePreferenceActions.setIsMetric, (state, action) => {
      state.isMetric = action.payload;
    })
    .addDefaultCase(state => state),
);
